<ng-container>
  @if (aiSummariesFF) {
    @if (isRecordingActive) {
      <div class="recording-banner" data-testid="recording-banner" nativeCursor>
        @if (isWideRecording) {
          <span class="recording-msg">
            Meeting wide recording in progress. Recording cannot be turned off at this time.
          </span>
        } @else {
          <span class="recording-msg">Recording in progress</span>
        }
        <mat-icon class="recording-icon" svgIcon="START_RECORDING"></mat-icon>
      </div>
    }

    @if (isAiSummariesRecordingActive) {
      <div class="recording-banner ai-summaries-recording" data-testid="recording-banner" nativeCursor>
        <span class="recording-msg">Transcription in progress</span>
        <mat-icon class="recording-icon" svgIcon="AI_TRANSCRIPTION"></mat-icon>
      </div>
    }
  } @else {
    @if (isRecording || isWideRecording) {
      <div class="recording-banner" data-testid="recording-banner" nativeCursor>
        @if (isWideRecording) {
          <span class="recording-msg">
            Meeting wide recording in progress. Recording cannot be turned off at this time.
          </span>
        } @else {
          <span class="recording-msg">Recording in progress</span>
        }
        <mat-icon class="recording-icon" svgIcon="START_RECORDING"></mat-icon>
      </div>
    }
  }
</ng-container>
